import { ReactNode, useEffect } from 'react';
import { useAuth } from '@/context/AuthContext';
import { intercomService } from '@/services/intercom';

interface IntercomProviderProps {
  children: ReactNode;
}

declare global {
  interface Window {
    Intercom: any;
    intercomSettings: {
      api_base: string;
      app_id: string;
    };
  }
}

const APP_ID = 'yzp59663';

export function IntercomProvider({ children }: IntercomProviderProps) {
  const { user, isAuthenticated } = useAuth();

  useEffect(() => {
    if (user && isAuthenticated) {
      intercomService.initForLoggedInUser(user);
    } else {
      intercomService.initForAnonymousUser();
    }

    return () => {
      intercomService.shutdown();
    };
  }, [user, isAuthenticated]);

  return <>{children}</>;
}

export default IntercomProvider;
